import type { FC } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { BrandsIcon, SchibstedIcon } from '../../../../Icon/Icon';
import { login } from '../../../../../services/schibstedAccount';
import { trackLoginClickEvent } from '../../../../../services/tracking/pulseEvents';
import { Button } from '../../../../Button/Button';

import * as styles from './LoginThumbnail.module.scss';

interface LoginThumbnailProps {
  variant?: string;
}

const LoginThumbnail: FC<LoginThumbnailProps> = ({ variant = 'empty' }) => {
  const { t } = useTranslation();
  const loginLabel = t('Log in');

  const handleLoginClick = () => {
    trackLoginClickEvent({
      button: {
        elementType: 'LoginThumbnail',
        title: loginLabel,
      },
    });

    login('continue-watching');
  };

  if (variant === 'empty') {
    return (
      <div className={styles.loginContainerEmpty}>
        <div className={classNames(styles.container, styles.empty)} />
      </div>
    );
  }
  return (
    <div className={styles.loginContainer}>
      <div className={styles.container}>
        <div className={styles.description}>{t('Log in for free')}</div>
        <Button
          size="large"
          variant="contained"
          active
          onClick={handleLoginClick}
          className={styles.button}
        >
          {loginLabel}
        </Button>
        <div className={styles.icons}>
          <SchibstedIcon className={styles.schibsted} />
          <BrandsIcon className={styles.brand} />
        </div>
      </div>
    </div>
  );
};

export { LoginThumbnail };
